
document.addEventListener("DOMContentLoaded", () => {

  var scrollLinks = document.querySelectorAll(".scroll-navigation ul li a")

  scrollLinks.forEach(el => {
    el.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();
      const step =  el.getAttribute('data-anchor')
      document.querySelector(`#${step}`).scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    });
  })


  const targets = document.querySelectorAll('.step')
  const observer = new IntersectionObserver(handleIntersection);

  targets.forEach((i) => {
    if (i) {
      observer.observe(i);
    }
  });

})

function handleIntersection(entries) {
  entries.map((entry) => {
    const step = entry.target.getAttribute('data-step');

    if (entry.isIntersecting) {
      document.querySelector(`.${step}`).classList.add('active')
    } else {
      document.querySelector(`.${step}`).classList.remove('active')
    }
  });
}